import { push } from 'connected-react-router';
import { actionCreators as tabActions } from 'react/api/actions/tabs';
import { getResourceTo } from './utils';

export function navigateToRouteDetails(route) {
  const { id, key } = route;

  const resource = getResourceTo("CustomTabs.tabName.Route");

  window.globalStore.dispatch(push(`/maps/route/${id}/details`));
  window.globalStore.dispatch(tabActions.updateTitle({
    key: `RouteDetails_${id}`,
    title: `${resource} (${key})`
  }));
}

export function navigateToRouteDetailsFocusedOnStop(route, stop) {
  const { id, key } = route;

  const resource = getResourceTo("CustomTabs.tabName.Route");

  window.globalStore.dispatch(push(`/maps/route/${id}/details/stop/${stop.id}`));
  window.globalStore.dispatch(tabActions.updateTitle({
    key: `RouteDetails_${id}`,
    title: `${resource} (${key})`
  }));
}
